import { Config, vsingleton } from '@niknevis/vue-modules'
import { MenuItemType } from '@/modules/common/layout/models/types/MenuItem'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'
import { adminMenuStoreItems } from '@/modules/common/layout/store/admin-menu-store-items'
import { panelMenuStoreItems } from '@/modules/common/layout/store/panel-menu-store-items'


@vsingleton()
export class MenuStore {
  constructor(
    private readonly userBootUseCase: UserBootUseCase
  ) {
  }

  public userType: string = Config.get('userType')
  private runningTickets: number | undefined
  miniDrawer = false
  forceClose = false


  setSidebar(payload) {
    this.runningTickets = payload.running_tickets
  }

  get items(): Array<MenuItemType> {

    if (this.userType === 'admin')
      return adminMenuStoreItems(this.userBootUseCase)
    else if (this.userType === 'panel')
      return panelMenuStoreItems(this.userBootUseCase)
  }

}
